import './Skeleton.css'

import React, { memo } from 'react'

import { isWeb } from '@common/config/env/env'
import useTheme from '@common/hooks/useTheme'
import { THEME_TYPES } from '@common/styles/themeConfig'
import { BORDER_RADIUS_PRIMARY } from '@common/styles/utils/common'

import { SkeletonLoaderProps } from './types'

const SkeletonLoader = ({
  width,
  height,
  borderRadius = BORDER_RADIUS_PRIMARY,
  style = {},
  lowOpacity = false,
  appearance
}: SkeletonLoaderProps & {
  style?: React.CSSProperties
}) => {
  const { theme, themeType } = useTheme()

  // On dark theme secondaryBackground (#111318) equals the card surface, so the
  // skeleton vanishes. Use the translucent-white overlay instead — a subtle
  // raised shimmer that stays visible without the harsh near-white of the
  // inverted surface. Light theme keeps the original light-grey skeleton.
  const bgKey =
    appearance || (themeType === THEME_TYPES.DARK ? 'quaternaryBackground' : 'secondaryBackground')

  return (
    <div
      className={`skeleton${lowOpacity ? ' low-opacity' : ''}`}
      style={{
        width: width as any,
        height: height as any,
        background: theme[bgKey] as any,
        borderRadius,
        ...(isWeb ? style : {})
      }}
    />
  )
}

export default memo(SkeletonLoader)
